import { z } from 'zod';

import { institutionDetailsCompanySchema } from '@/services/api/profile';

export const institutionFuturesCompanyInformationSchema = z.object({
  leiNumber: institutionDetailsCompanySchema.shape.leiNumber.nonoptional(),
});

export type InstitutionFuturesCompanyInformation = z.infer<typeof institutionFuturesCompanyInformationSchema>;

export type InstitutionFuturesCompanyInformationOrDefaults = InstitutionFuturesCompanyInformation | Partial<InstitutionFuturesCompanyInformation>;
